import { render, staticRenderFns } from "./supportedWalletsItem.vue?vue&type=template&id=ebb2a586&scoped=true"
import script from "./supportedWalletsItem.vue?vue&type=script&lang=js"
export * from "./supportedWalletsItem.vue?vue&type=script&lang=js"
import style0 from "./supportedWalletsItem.vue?vue&type=style&index=0&id=ebb2a586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb2a586",
  null
  
)

export default component.exports